<div class="row">
  <div class="container">
    
    <div class="filters-container">
      <form [formGroup]="filtrosForm">
        <h1 class="color-main" style="margin-bottom: 14px; margin-left: 10px;">Seguimiento a Cotizaciones</h1>
        
        <div class="filter-row-group">
          <div class="row filters-row">
            <div class="col-xs-12 col-md-6">
              <h3 class="filter-subtitle">FECHA DE LA COTIZACIÓN:</h3>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <div class="label-container">
                    <mat-label>Fecha Desde</mat-label>
                  </div>
                  <mat-form-field appearance="outline">
                    <input matInput 
                           [min]="minDate" 
                           [max]="maxDate" 
                           formControlName="fechaCotizacionDesde"
                           [matDatepicker]="pickerCotizacionDesde" 
                           placeholder="dd/mm/yyyy">
                    <mat-datepicker-toggle matSuffix [for]="pickerCotizacionDesde"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCotizacionDesde></mat-datepicker>
                    <mat-hint style="color: red" *ngIf="filtrosForm.get('fechaCotizacionDesde')?.hasError('required') && filtrosForm.get('fechaCotizacionDesde')?.touched">
                      Campo requerido
                    </mat-hint>
                  </mat-form-field>
                </div>
                <div class="col-xs-12 col-md-6">
                  <div class="label-container">
                    <mat-label>Fecha Hasta</mat-label>
                  </div>
                  <mat-form-field appearance="outline">
                    <input matInput 
                           [min]="minDate" 
                           [max]="maxDate" 
                           formControlName="fechaCotizacionHasta"
                           [matDatepicker]="pickerCotizacionHasta" 
                           placeholder="dd/mm/yyyy">
                    <mat-datepicker-toggle matSuffix [for]="pickerCotizacionHasta"></mat-datepicker-toggle>
                    <mat-datepicker #pickerCotizacionHasta></mat-datepicker>
                    <mat-hint style="color: red" *ngIf="filtrosForm.hasError('fechaCotizacionInvalida')">
                      La fecha desde no puede ser posterior a la fecha hasta
                    </mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-3">
              <h3 class="filter-subtitle-spacer">&nbsp;</h3>
              <div class="label-container">
                <mat-label>Estado de la Cotización</mat-label>
              </div>
              <mat-form-field appearance="outline">
                <mat-select formControlName="estadoCotizacion">
                  <mat-option value="">Todos</mat-option>
                  <mat-option *ngFor="let estado of estadosCotizacion" [value]="estado.value">
                    {{estado.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-md-3">
              <h3 class="filter-subtitle-spacer">&nbsp;</h3>
              <div class="label-container">
                <mat-label>Tipo de Solicitud</mat-label>
              </div>
              <mat-form-field appearance="outline">
                <mat-select formControlName="tipoSolicitud" multiple>
                  <mat-option *ngFor="let tipo of tipoSolicitud" [value]="tipo.value">
                    {{tipo.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="filter-row-group">
          <div class="row filters-row">
            <div class="col-xs-12">
              <h3 class="filter-subtitle">FECHA DE CIERRE:</h3>
            </div>
          </div>
          <div class="row filters-row">
            <div class="col-xs-12 col-md-3">
              <div class="label-container">
                <mat-label>Fecha Desde</mat-label>
              </div>
              <mat-form-field appearance="outline">
                <input matInput 
                       [min]="minDate" 
                       [max]="maxDate" 
                       formControlName="fechaCierreDesde"
                       [matDatepicker]="pickerCierreDesde" 
                       placeholder="dd/mm/yyyy">
                <mat-datepicker-toggle matSuffix [for]="pickerCierreDesde"></mat-datepicker-toggle>
                <mat-datepicker #pickerCierreDesde></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-md-3">
              <div class="label-container">
                <mat-label>Fecha Hasta</mat-label>
              </div>
              <mat-form-field appearance="outline">
                <input matInput 
                       [min]="minDate" 
                       [max]="maxDate" 
                       formControlName="fechaCierreHasta"
                       [matDatepicker]="pickerCierreHasta" 
                       placeholder="dd/mm/yyyy">
                <mat-datepicker-toggle matSuffix [for]="pickerCierreHasta"></mat-datepicker-toggle>
                <mat-datepicker #pickerCierreHasta></mat-datepicker>
                <mat-hint style="color: red" *ngIf="filtrosForm.hasError('fechaCierreInvalida')">
                  La fecha desde no puede ser posterior a la fecha hasta
                </mat-hint>
              </mat-form-field>
            </div>

            <!-- Asesor comercial -->
            <div 
              #asesorSelectContainer
              class="col-xs-12 col-md-6 asesor-col">
              <div class="label-container">
                <mat-label>Asesor comercial</mat-label>
              </div>

              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="asesorComercial"
                  panelClass="asesor-select-panel"
                  panelWidth="auto"
                  disableOptionCentering
                  (openedChange)="onAsesorSelectAbierto($event)">

                  <!-- Buscador -->
                  <mat-option
                    class="asesor-search-option"
                    (click)="$event.stopPropagation()">

                    <div
                      class="asesor-search-container"
                      (click)="$event.stopPropagation()">

                      <input
                        #asesorSearchInput
                        matInput
                        type="text"
                        placeholder="Buscar por código o nombre"
                        autocomplete="off"
                        [value]="asesorBusqueda"
                        (input)="filtrarAsesores($any($event.target).value)"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()">

                      <mat-icon>search</mat-icon>
                    </div>
                  </mat-option>

                  <mat-option value="">
                    Todos
                  </mat-option>

                  <mat-option
                    *ngFor="let asesor of filteredAsesores"
                    [value]="asesor.codigo">

                    {{ asesor.codigo }} - {{ asesor.nombre }}
                  </mat-option>

                  <mat-option
                    *ngIf="filteredAsesores.length === 0"
                    disabled>

                    No hay asesores coincidentes
                  </mat-option>

                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Botón Limpiar Filtros -->
        <div class="row">
          <div class="col-xs-12">
            <div class="button-container-centered">
              <button mat-raised-button type="button" (click)="limpiarFiltros()" class="btnLimpiarFiltrosCentrado">
                LIMPIAR FILTROS
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="tabs-wrapper">
      <div class="seguimiento-tabs">
        <button type="button"
                class="tab-button"
                [class.active]="activeTab === 'dashboard'"
                (click)="cambiarTab('dashboard')">
          DASHBOARD
        </button>
        <button type="button"
                class="tab-button"
                [class.active]="activeTab === 'registros'"
                (click)="cambiarTab('registros')">
          REGISTROS
        </button>
      </div>

      <div class="tab-panel" *ngIf="activeTab === 'dashboard'">
        <div class="dashboard-top-row">
          <div class="metrics-column">
            <div class="metric-card">
              <span class="metric-label">Total de cotizaciones año actual</span>
              <span class="metric-value">{{ totalCotizaciones }}</span>
            </div>
            <div class="metric-card">
              <span class="metric-label">Porcentaje de cumplimiento meta</span>
              <span class="metric-value">{{ porcentajeCumplimientoMeta }}%</span>
            </div>
            <div class="metric-card">
              <span class="metric-label">Tiempo promedio de cierre (días)</span>
              <span class="metric-value">{{ tiempoPromedioCierre }}</span>
            </div>
          </div>
          
          <div class="chart-card chart-line-main">
            <div class="chart-header-line">
              CANTIDAD DE COTIZACIONES
            </div>
            <div class="line-chart" *ngIf="lineChartData.length; else noLineData">
              <svg [attr.viewBox]="lineChartViewBox" preserveAspectRatio="xMidYMid meet">

                <text x="12" y="120" class="y-axis-title" transform="rotate(-90, 12, 120)">Cantidad de cotizaciones</text>

                <ng-container *ngFor="let g of lineChartGridLines">
                  <line [attr.x1]="70" [attr.y1]="g.y" [attr.x2]="600" [attr.y2]="g.y" class="grid-line" />
                  <text [attr.x]="64" [attr.y]="g.y + 4" class="y-axis-label">{{ g.value }}</text>
                </ng-container>

                <line x1="70" y1="225" x2="600" y2="225" class="axis-line" />

                <polyline [attr.points]="lineChartPolylinePoints" />

                <ng-container *ngFor="let node of lineChartNodes">
                  <circle [attr.cx]="node.cx" [attr.cy]="node.cy" r="3"
                          matTooltip="{{ node.label }}: {{ node.value }} cotizaciones"
                          matTooltipPosition="above"></circle>
                  <text *ngIf="node.showLabel"
                        [attr.x]="node.labelX" [attr.y]="node.labelY"
                        class="x-axis-label"
                        [attr.transform]="node.labelTransform">{{ node.label }}</text>
                </ng-container>
              </svg>
            </div>
            <ng-template #noLineData>
              <div class="empty-state">Sin datos disponibles para el periodo seleccionado.</div>
            </ng-template>
          </div>
        </div>

        <div class="charts-bottom-row">
          <div class="chart-card chart-pie">
            <div class="chart-header-line">
              ESTADO DE LA COTIZACIÓN
            </div>
            <div class="pie-area" *ngIf="pieChartData.length; else noPieData">
              <div class="pie-wrapper">
                <!-- SVG pastel con porcentajes -->
                <svg viewBox="0 0 220 220" width="200" height="200" class="pie-svg">
                  <g *ngFor="let sl of pieSvgSlices">
                    <path [attr.d]="sl.path" [attr.fill]="sl.color" />
                    <text [attr.x]="sl.labelX" [attr.y]="sl.labelY" class="pie-pct-label">{{ sl.pct }}</text>
                  </g>
                </svg>
                <!-- Leyenda debajo en 2 columnas -->
                <div class="pie-legend">
                  <div class="legend-item"
                       *ngFor="let segmento of pieChartData"
                       [style.--legend-color]="segmento.color"
                       matTooltip="{{ segmento.label | titlecase }}: {{ segmento.value }} cotizaciones">
                    <span class="legend-dot"></span>
                    <span class="legend-label">{{ segmento.label | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noPieData>
              <div class="empty-state">Sin información para construir el gráfico.</div>
            </ng-template>
          </div>

          <div class="chart-card chart-bar">
            <div class="chart-header-line">SEGUIMIENTO</div>
            <div class="bar-chart-svg-wrapper" *ngIf="tieneSeguimientoDatos; else noSeguimiento">
              <svg [attr.viewBox]="barChartViewBox" preserveAspectRatio="xMidYMid meet">
                <!-- Título eje Y rotado -->
                <text x="12" y="100" class="y-axis-title" transform="rotate(-90, 12, 100)">Cantidad de cotizaciones</text>
                <!-- Grid lines + números eje Y -->
                <ng-container *ngFor="let g of seguimientoSvgGridLines">
                  <line [attr.x1]="50" [attr.y1]="g.y" [attr.x2]="370" [attr.y2]="g.y" class="grid-line" />
                  <text [attr.x]="44" [attr.y]="g.y + 4" class="y-axis-label">{{ g.value }}</text>
                </ng-container>
                <!-- Línea base eje X -->
                <line x1="50" y1="180" x2="370" y2="180" class="axis-line" />
                <!-- Barras -->
                <ng-container *ngFor="let bar of seguimientoSvgBars">
                  <rect [attr.x]="bar.rx" [attr.y]="bar.ry" [attr.width]="bar.rw" [attr.height]="bar.rh"
                        class="svg-bar"
                        matTooltip="{{ bar.label }}: {{ bar.value }}"
                        matTooltipPosition="above" />
                  <text [attr.x]="bar.valueX" [attr.y]="bar.valueY" class="bar-svg-value">{{ bar.value }}</text>
                  <text [attr.x]="bar.labelX" [attr.y]="bar.labelY" class="bar-svg-label">{{ bar.label }}</text>
                </ng-container>
                <!-- Label eje X -->
                <text x="210" y="235" class="x-axis-title">Seguimiento</text>
              </svg>
            </div>
            <ng-template #noSeguimiento>
              <div class="empty-state">No hay registros de seguimiento.</div>
            </ng-template>
          </div>

          <div class="chart-card chart-bar">
            <div class="chart-header-line">COTIZACIONES POR LÍNEA DE NEGOCIO</div>
            <div class="bar-chart-svg-wrapper" *ngIf="tieneLineasDatos; else noLineas">
              <svg [attr.viewBox]="barChartViewBox" preserveAspectRatio="xMidYMid meet">
                <!-- Título eje Y rotado -->
                <text x="12" y="100" class="y-axis-title" transform="rotate(-90, 12, 100)">Cantidad de cotizaciones</text>
                <!-- Grid lines + números eje Y -->
                <ng-container *ngFor="let g of lineasNegocioSvgGridLines">
                  <line [attr.x1]="50" [attr.y1]="g.y" [attr.x2]="370" [attr.y2]="g.y" class="grid-line" />
                  <text [attr.x]="44" [attr.y]="g.y + 4" class="y-axis-label">{{ g.value }}</text>
                </ng-container>
                <!-- Línea base eje X -->
                <line x1="50" y1="180" x2="370" y2="180" class="axis-line" />
                <!-- Barras -->
                <ng-container *ngFor="let bar of lineasNegocioSvgBars">
                  <rect [attr.x]="bar.rx" [attr.y]="bar.ry" [attr.width]="bar.rw" [attr.height]="bar.rh"
                        class="svg-bar"
                        matTooltip="{{ bar.label }}: {{ bar.value }}"
                        matTooltipPosition="above" />
                  <text [attr.x]="bar.valueX" [attr.y]="bar.valueY" class="bar-svg-value">{{ bar.value }}</text>
                  <text [attr.x]="bar.labelX" [attr.y]="bar.labelY" class="bar-svg-label">{{ bar.label }}</text>
                </ng-container>
                <!-- Label eje X -->
                <text x="210" y="235" class="x-axis-title">Línea de Negocio</text>
              </svg>
            </div>
            <ng-template #noLineas>
              <div class="empty-state">Sin cotizaciones por línea de negocio.</div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="tab-panel" *ngIf="activeTab === 'registros'">
        <div class="registros-toolbar">
          <div class="busqueda-general">
            <div class="busqueda-input">
              <input id="busquedaGeneralInput"
                     name="busquedaGeneral"
                     type="text"
                     class="busqueda-input-control"
                     placeholder="Buscador general"
                     [(ngModel)]="busquedaGeneral"
                     (keyup.enter)="aplicarBusquedaGeneral()">
              <button type="button"
                      class="busqueda-icon-button"
                      aria-label="Buscar"
                      (click)="aplicarBusquedaGeneral()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
          <div class="toolbar-buttons">
            <button type="button" class="toolbar-button secondary" (click)="limpiarBusquedaGeneral()">
              LIMPIAR
            </button>
            <button type="button" class="toolbar-button primary" (click)="exportarRegistros()">
              <mat-icon>file_download</mat-icon>
              EXPORTAR
            </button>
          </div>
        </div>

        <div class="example-container mat-elevation-z2">
          <div class="example-table-container">
            <table mat-table [dataSource]="dataSource">

              <!-- Columna Asesor Comercial -->
              <ng-container matColumnDef="asesorComercial">
                <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">ASESOR COMERCIAL</th>
                <td mat-cell *matCellDef="let row">{{ row.asesorCodigo }} - {{ row.asesorNombre }}</td>
              </ng-container>

              <!-- Columna Número de Cotización -->
              <ng-container matColumnDef="numeroCotizacion">
                <th mat-header-cell *matHeaderCellDef style="min-width: 80px; text-align: center;">NO. COTIZACIÓN</th>
                <td mat-cell *matCellDef="let row">{{ row.numeroCotizacion }}</td>
              </ng-container>

              <!-- Columna Fecha de Creación -->
              <ng-container matColumnDef="fechaCreacion">
                <th mat-header-cell *matHeaderCellDef style="min-width: 110px; text-align: center;">FECHA DE CREACIÓN</th>
                <td mat-cell *matCellDef="let row">{{ row.fechaCreacion | date: 'dd/MM/yyyy' }}</td>
              </ng-container>

              <!-- Columna Tipo de Solicitud -->
              <ng-container matColumnDef="tipoSolicitud">
                <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">TIPO DE SOLICITUD</th>
                <td mat-cell *matCellDef="let row">{{ row.tipoSolicitud }}</td>
              </ng-container>

              <!-- Columna Línea de Negocio -->
              <ng-container matColumnDef="lineasNegocio">
                <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">LÍNEA DE NEGOCIO</th>
                <td mat-cell *matCellDef="let row">{{ obtenerLineasNegocioResumen(row.lineasNegocio) }}</td>
              </ng-container>

              <!-- Columna Estado -->
              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px; text-align: center;">ESTADO</th>
                <td mat-cell *matCellDef="let row">{{ row.estado | titlecase }}</td>
              </ng-container>

              <!-- Columna Fecha de Cierre -->
              <ng-container matColumnDef="fechaCierre">
                <th mat-header-cell *matHeaderCellDef style="min-width: 110px; text-align: center;">FECHA DE CIERRE</th>
                <td mat-cell *matCellDef="let row">{{ row.fechaCierre ? (row.fechaCierre | date: 'dd/MM/yyyy') : 'NO APLICA' }}</td>
              </ng-container>

              <!-- Columna Cumplimiento del Seguimiento -->
              <ng-container matColumnDef="seguimiento">
                <th mat-header-cell *matHeaderCellDef style="min-width: 160px; text-align: center;">CUMPLIMIENTO DEL SEGUIMIENTO</th>
                <td mat-cell *matCellDef="let row">
                  <div class="seguimiento-cell">
                    <span>{{ textoCumplimientoSeguimiento(row) }}</span>
                    <span *ngIf="clasePuntoSeguimiento(row)" class="seguimiento-dot" [ngClass]="clasePuntoSeguimiento(row)"></span>
                  </div>
                </td>
              </ng-container>

              <!-- Columna Acciones -->
              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">ACCIONES</th>
                <td mat-cell *matCellDef="let row">
                  <div class="fechaSesion">
                    <button 
                      mat-icon-button 
                      (click)="verPdfCotizacion(row)"
                      matTooltip="Ver PDF" 
                      style="color: #0372b9;">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button 
                      mat-icon-button 
                      (click)="verSeguimientoCotizacion(row)"
                      matTooltip="Ver seguimiento" 
                      class="btnTable">
                      <mat-icon class="btnDownloadSession" style="padding-bottom: 5px;">description</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell contenData" colspan="9">No se encontraron registros con los filtros aplicados.</td>
              </tr>
            </table>
          </div>
          <mat-paginator 
            #paginator 
            [pageSizeOptions]="pageSizeOptions" 
            [pageSize]="10"
            showFirstLastButtons 
            aria-label="Seleccione página">
          </mat-paginator>
        </div>
      </div>
    </div>

  </div>
</div>
